









import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class Button extends Vue {
  @Prop({ default: "" })
  private type?: string;
  @Prop({ default: true })
  private border?: boolean;
  @Prop({ default: false })
  private disabled?: boolean;

  private mounted() {}

  @Emit("click")
  private clickButton() {}
}
